module.exports = __webpack_public_path__ + "img/logo_paypal.e78a30c6.svg";